import React, { useEffect } from 'react';
import { useState } from 'react';

import { UploadOutlined } from '@ant-design/icons';
import { DeleteOutlined } from '@ant-design/icons';
import { faFileLines, faFile, faFilePdf, faFileExcel, faFileWord, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Divider, Popconfirm, Progress, Upload, message } from 'antd';
import type { RcFile } from 'antd/es/upload/interface';

import Configurazione from '../Configurazione';
import sessionManager, { eVariableType } from '../SessionManager';
import { GetErrorMessage } from '../Utility';
import api from '../api';
import stringres from '../translations/stringres';
import AllegatoPreview from './AllegatoPreview';

export default function Allegati(props) {
    const [progress, setProgress] = useState(0);
    const [data, setData] = useState([]);
    const [defaultFileList, setDefaultFileList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);
    const [idAllegato, setidAllegato] = useState(null);
    const [nomeFile, setNomeFile] = useState('');

    const configurazione = Configurazione();

    const closeModal = () => {
        setModalOpen(false);
        setidAllegato(null);
    };

    useEffect(() => {
        fetch();
    }, []);

    async function fetch() {
        try {
            let sWhere = '';
            if (!isNaN(props.idAttivitaOpportunita)) sWhere = '&idAttivitaOpportunita=' + props.idAttivitaOpportunita;
            if (!isNaN(props.idOpportunita)) sWhere = '&idOpportunita=' + props.idOpportunita;
            if (!isNaN(props.idEvento)) sWhere = '&idEvento=' + props.idEvento;

            const result = await api.get(
                'CRM/Allegati?idSocieta=' + sessionManager.get(eVariableType.IDSocieta) + sWhere
            );
            
            if (result != null && result.data != null) {
                setData(result.data);
            }
        } catch (error) {
            message.error(error.response.data.message, 5);
        }
    }
    function onChange(info) {
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    }

    const uploadFile = async (options) => {
        const { onSuccess, onError, file, onProgress } = options;
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('idSocieta', String(sessionManager.get(eVariableType.IDSocieta)));
            formData.append('nomeFile', file.name);

            if (!isNaN(props.idAttivitaOpportunita))
                formData.append('idAttivitaOpportunita', props.idAttivitaOpportunita.toString());
            if (!isNaN(props.idOpportunita)) formData.append('idOpportunita', props.idOpportunita);
            if (!isNaN(props.idEvento)) formData.append('idEventoCliente', props.idEvento);
            formData.append('idOperatore', String(sessionManager.get(eVariableType.IDOperatore)));

            const config = {
                headers: { 'content-type': 'multipart/form-data' },
                onUploadProgress: (event) => {
                    const percent = Math.floor((event.loaded / event.total) * 100);
                    setProgress(percent);
                    if (percent === 100) {
                        setTimeout(() => setProgress(0), 1000);
                    }
                    onProgress({ percent: (event.loaded / event.total) * 100 });
                },
            };

            const response = await api.post('CRM/Allegato/Insert', formData, config);

            if (response != null && response.status === 200) {
                fetch();
            }
        } catch (error) {
            GetErrorMessage(error);
        } finally {
            setLoading(false);
        }
    };

    function getImageByFileType(filename) {
        const fileExtension = filename.split('.').pop();

        switch (fileExtension.toUpperCase()) {
            case 'TXT':
                return <FontAwesomeIcon size="3x" icon={faFileLines} />;
            case 'DOC':
            case 'DOCX':
                return <FontAwesomeIcon size="3x" icon={faFileWord} />;
            case 'XLS':
            case 'XLSX':
                return <FontAwesomeIcon size="3x" icon={faFileExcel} />;
            case 'PDF':
                return <FontAwesomeIcon size="3x" icon={faFilePdf} />;
            case 'PNG':
            case 'JPG':
            case 'JPEG':
            case 'BMP':
            case 'GIF':
                return <FontAwesomeIcon size="3x" icon={faImage} />;
            default:
                return <FontAwesomeIcon size="3x" icon={faFile} />;
        }
    }

    async function openFile(e) {
        try {
            setidAllegato(e.idAllegato);
            setNomeFile(e.nomeFileOrigine);
            setModalOpen(true);
        } catch (error) {
            message.error(error.response.data.message);
        }
    }

    async function confermacancellazione(e) {
        try {
            const res = await api.delete(
                'CRM/Allegati/Delete?idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&idAllegato=' +
                    e.idAllegato
            );

            if (res != null && res.status === 200) {
                fetch();
            }
        } catch (error) {
            message.error(error.message, 5);
        }
    }

    const beforeUpload = (file: RcFile) => {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            message.error('Image must smaller than 10MB!');
        }
        return isLt2M;
    };

    return (
        <div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {data?.map((item: any) => (
                    <Card
                        key={item?.idAllegato}
                        style={{ marginRight: '16px' }}
                        title={item.nomeFileOrigine}
                        extra={
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Popconfirm
                                    title={stringres.t('eliminaelementoselezionato').toString()}
                                    description={stringres.t('eliminare').toString()}
                                    onConfirm={() => confermacancellazione(item)}
                                    okText={stringres.t('si').toString()}
                                    cancelText={stringres.t('no').toString()}
                                >
                                    <Button style={{ border: 'none' }} icon={<DeleteOutlined />}></Button>
                                </Popconfirm>
                            </div>
                        }
                    >
                        <Button
                            style={{ width: '100px', height: '100px', border: 'none' }}
                            onClick={() => openFile(item)}
                        >
                            {getImageByFileType(item.nomeFileOrigine)}
                        </Button>
                    </Card>
                ))}
            </div>
            <Divider></Divider>
            <Upload
                beforeUpload={beforeUpload}
                customRequest={uploadFile} //onChange={handleFileUpload}
                showUploadList={false} // Hide remove icon
                multiple={false} // Allow only single file upload
                disabled={loading}
                progress={{
                    strokeColor: { '0%': '#108ee9', '100%': '#87d068' },
                    strokeWidth: 3,
                    format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
                }}
            >
                <Button icon={<UploadOutlined />} loading={loading}>
                    {loading ? 'Uploading' : 'Select File'}
                </Button>
            </Upload>
            {progress > 0 ? <Progress percent={progress} /> : null}
            {idAllegato && (
                <AllegatoPreview
                    Open={modalOpen}
                    onClose={closeModal}
                    idAllegato={idAllegato}
                    idSocieta={Number(sessionManager.get(eVariableType.IDSocieta))}
                    nomeFile={nomeFile}
                    idDocumento={null}
                />
            )}
        </div>
    );
}
